import { BasicUserDataFromToken } from "@covertree/auth";

import environment from "@environment/variables";

import Rox from "rox-browser";

export const featureFlags = {
  // already on in prod at time of migration
  continueQuote: new Rox.Flag(true),
  overviewMetrics: new Rox.Flag(true),
  overviewRecentQuotes: new Rox.Flag(true),
  pendingList: new Rox.Flag(true),
  policiesList: new Rox.Flag(true),
  policyDetails: new Rox.Flag(true),
  policyDetailsNotes: new Rox.Flag(true),
  policyDetailsPersonalDetailsTab: new Rox.Flag(true),
  policyDetailsDocumentUpload: new Rox.Flag(true),
  quotesList: new Rox.Flag(true),
  sendEsignReminder: new Rox.Flag(true),
  viewUWReasons: new Rox.Flag(true),
  updatePriorClaimsOnGetPriorClaimsQuery: new Rox.Flag(true),
  useFlexiblePriorClaimsQuestions: new Rox.Flag(false),
  useNewOffersAndSelectedQuotePricing: new Rox.Flag(false),

  // off (or undefined) in prod at time of migration
  landlordQuotesEnabled: new Rox.Flag(false),
  policyDetailsAdditionalInterests: new Rox.Flag(false),
  newAdditionalInterestTabEnabled: new Rox.Flag(false),
  endorsementsTabEnabled: new Rox.Flag(false),
  claimsList: new Rox.Flag(false),
  discardRenewal: new Rox.Flag(false),
  downloadRenewalOffer: new Rox.Flag(false),
  renewalDetails: new Rox.Flag(false),
  dynamicEmailValidation: new Rox.Flag(false),
  emailValidation: new Rox.Flag(false),
  policyDetailsRenewalsList: new Rox.Flag(false),
  renewalDetailsDocument: new Rox.Flag(false),
  renewalsList: new Rox.Flag(false),
  resendRenewalOffer: new Rox.Flag(false),
  retryPaymentIssuance: new Rox.Flag(false),
  retryFailedRenewalOperations: new Rox.Flag(false),
  bulkEsignReminders: new Rox.Flag(false),
  signPolicyManually: new Rox.Flag(false),
  bookConversions: new Rox.Flag(false),
  agentPortalSearch: new Rox.Flag(false),
  noEmailSolution: new Rox.Flag(false),
  renewalsListForExternalAgents: new Rox.Flag(false),
  retrySendingRenewalOffer: new Rox.Flag(false),
  banners: new Rox.Flag(false),
  disableInsuranceScoreFetching: new Rox.Flag(false),
  enableWebTracking: new Rox.Flag(false),
  useNewAgentIntegration: new Rox.Flag(false),

  arizonaThirdRevisionDate: new Rox.RoxString("2024-07-15"),
  michiganRevisionDate: new Rox.RoxString("2025-01-01"), // TODO: change to actual revision date of "2024-10-01" when ready
  monthlyPaymentPlanStates: new Rox.RoxString("AZ, GA, IL, KY, MI, MS, NM"),
};

export const initializeFeatureFlags = async (appName: string) => {
  Rox.register(appName, featureFlags);
  await Rox.setup(environment.keys.roxKey);
};

/**
 * Sets up custom properties for CloudBees from logged in user and updates feature flags
 * @param groups
 */
export const setupFeatureFlagsUserDetails = ({
  groups,
}: BasicUserDataFromToken) => {
  const isInternal = groups.some(
    (group) => group.startsWith("ct_") || group === "super_admin"
  );
  Rox.setCustomBooleanProperty("isInternal", isInternal);
  Rox.unfreeze();
};

/**
 * Clears custom properties for CloudBees and updates feature flags
 */
export const clearFeatureFlagsUserDetails = () => {
  Rox.setCustomStringProperty("email", "");
  Rox.setCustomBooleanProperty("isInternal", false);
  Rox.unfreeze();
};
